import { z } from "zod";
export const IntegrationProviderEnum = {
    STRIPE: "stripe",
    SWIKLY: "swikly",
    PLUNK: "plunk",
};
export const integrationProviderSchema = z.enum([
    IntegrationProviderEnum.STRIPE,
    IntegrationProviderEnum.SWIKLY,
    IntegrationProviderEnum.PLUNK,
]);
